import Swiper from 'swiper';
import { Autoplay, EffectCoverflow, EffectFade, Mousewheel, Pagination } from 'swiper/modules';
import jsKit from './jsKit';
import kitman from './kitman';

export const swipers = (() => {
  const defaults = {
    debugMode: false,
  };

  return {
    // STEP 4 - init swiper for team thumbnails
    initOutfitsListSwiper: (method = '') => {
      if (!document.querySelector('#swiper-outfits-list')) {
        return;
      }

      const outfitsListSwiper = new Swiper('#swiper-outfits-list', {
        observer: true,
        simulateTouch: true,
        freeMode: true,
        spaceBetween: 10,
        slidesPerView: 'auto',
      });
    },

    initOutfitsOfferSwiper: () => {
      if (!document.querySelector('#swiper-offer-outfits')) {
        return;
      }

      const outfitsSwiper = new Swiper('#swiper-offer-outfits', {
        init: false,
        modules: [Pagination, Autoplay],
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        speed: 1200,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        },
        pagination: {
          el: '#swiper-offer-outfits .swiper-pagination',
          clickable: true,
        },
        breakpoints: {
          320: {
            slidesPerView: 1.2,
          },
          576: {
            slidesPerView: 1.6,
          },
          768: {
            slidesPerView: 2,
          },
          1200: {
            slidesPerView: 3,
          },
        },
      });

      ['init', 'slideChange'].forEach((event) => outfitsSwiper.on(event, () => {
        const swiperOutfits = document.querySelector('#swiper-offer-outfits');
        swiperOutfits.querySelectorAll('#swiper-offer-outfits .swiper-pagination-bullet').forEach((el) => {
          el.classList.remove('count-down');
        });
        const activeBullet = swiperOutfits.querySelector('.swiper-pagination-bullet-active');
        if (activeBullet) {
          setInterval(() => {
            activeBullet.classList.add('count-down');
          }, 1);
        }
      }));

      outfitsSwiper.init();
    },

    // STEP 1 - init swiper for sport choose
    initPlayersSwiper: () => {
      if (!document.querySelector('#swiper-player')) {
        return;
      }

      const playersSwiper = new Swiper('#swiper-player', {
        modules: [EffectCoverflow, Pagination],
        effect: 'coverflow',
        initialSlide: 3,
        threshold: 10,
        loop: false,
        slidesPerView: 'auto',
        grabCursor: false,
        centeredSlides: true,
        breakpoints: {
          320: {
            coverflowEffect: {
              depth: 0,
              modifier: 6,
              rotate: 0,
              scale: 0.98,
              slideShadows: false,
              stretch: 4,
            },
          },
          768: {
            coverflowEffect: {
              depth: 0,
              modifier: 6,
              rotate: 0,
              scale: 0.98,
              slideShadows: false,
              stretch: 8,
            },
          },
          1200: {
            coverflowEffect: {
              depth: 0,
              modifier: 6,
              rotate: 0,
              scale: 0.98,
              slideShadows: false,
              stretch: 12,
            },
          },
        },
        pagination: {
          el: '#swiper-player .swiper-pagination',
          dynamicBullets: false,
          clickable: true,
        },
      });
    },

    // Trusted Us - outfits
    initTrustedUsSwiper: () => {
      if (!document.querySelector('#swiper-trusted-us')) {
        return;
      }

      const trustedUsSwiper = new Swiper('#swiper-trusted-us', {
        modules: [Pagination, Autoplay],
        spaceBetween: 0,
        slidesPerView: 1,
        speed: 1000,
        loop: true,
        pagination: {
          el: '#swiper-trusted-us > .swiper-pagination',
          clickable: true,
        },
        autoplay: {
          delay: 2500,
          disableOnInteraction: true,
        },
      });
    },

    // Print House - outfits
    initOutfitsSwiper: (method = '') => {
      if (!document.querySelector('#swiper-outfits')) {
        return;
      }

      const outfitsSwiper = new Swiper('#swiper-outfits', {
        modules: [EffectFade, Autoplay],
        spaceBetween: 0,
        slidesPerView: 1,
        speed: 500,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        loop: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: true,
        },
      });
    },

    // CLUB SERVICE, PRINT HOUSE - full page swiper
    initFullPageSwiper: () => {
      if (!document.querySelector('.fullPageSwiper')) {
        return;
      }

      const breakpoint = window.matchMedia('(min-width:1200px) and (min-height: 800px)');
      let fullPageSwiper;

      const enableSwiper = () => {
        fullPageSwiper = new Swiper('.fullPageSwiper', {
          modules: [Pagination, Mousewheel],
          direction: 'vertical',
          speed: 700,
          threshold: 8,
          slidesPerView: 1,
          spaceBetween: 0,
          mousewheel: {
            thresholdDelta: 10,
            thresholdTime: 10,
          },
          pagination: {
            el: '.fullPageSwiper > .swiper-pagination',
            clickable: true,
          },
        });
      };

      const breakpointChecker = () => {
        if (breakpoint.matches) {
          enableSwiper();
        } else if (fullPageSwiper !== undefined) {
          fullPageSwiper.destroy(true, true);
        }
      };

      breakpoint.addEventListener('change', breakpointChecker);
      breakpointChecker();
    },

    // POK - trusted us swiper
    initPOKTrustedUsSwiper: () => {
      if (!document.querySelector('#swiper-pok-trusted-us')) {
        return;
      }

      const trustedUsSwiper = new Swiper('#swiper-pok-trusted-us', {
        modules: [Pagination],
        slidesPerView: 1,
        breakpoints: {
          576: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
          992: {
            slidesPerView: 4,
          },
          1200: {
            slidesPerView: 5,
          },
          1400: {
            slidesPerView: 6,
          },
        },
        pagination: {
          el: '#swiper-pok-trusted-us .swiper-pagination',
          dynamicBullets: false,
          clickable: true,
        },
      });
    },

    // POK - our catalogues swiper
    initPOKCataloguesSwiper: () => {
      if (!document.querySelector('#swiper-pok-catalogues')) {
        return;
      }

      const cataloguesSwiper = new Swiper('#swiper-pok-catalogues', {
        modules: [Pagination],
        slidesPerView: 1,
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          1200: {
            slidesPerView: 3,
          },
        },
        pagination: {
          el: '#swiper-pok-catalogues .swiper-pagination',
          dynamicBullets: false,
          clickable: true,
        },
      });
    },

    // POK - our clients swiper
    initPOKOurClientsSwiper: () => {
      if (!document.querySelector('#swiper-pok-our-clients')) {
        return;
      }

      const ourClientsSwiper = new Swiper('#swiper-pok-our-clients', {
        modules: [Pagination],
        slidesPerView: 1,
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 4,
          },
        },
        pagination: {
          el: '#swiper-pok-our-clients .swiper-pagination',
          dynamicBullets: false,
          clickable: true,
        },
      });
    },

    // POK - Statistics swiper
    initPOKStatisticsSwiper: () => {
      if (!document.querySelector('#swiper-pok-statistics')) {
        return;
      }

      const statisticsSwiper = new Swiper('#swiper-pok-statistics', {
        modules: [Pagination],
        slidesPerView: 1,
        breakpoints: {
          576: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
          992: {
            slidesPerView: 4,
          },
        },
        pagination: {
          el: '#swiper-pok-statistics .swiper-pagination',
          dynamicBullets: false,
          clickable: true,
        },
      });
    },

    // FOOTER - feature swiper
    initFeaturesSwiper: () => {
      if (!document.querySelector('#swiper-features')) {
        return;
      }

      const featuresSwiper = new Swiper('#swiper-features', {
        modules: [Pagination],
        slidesPerView: 1,
        breakpoints: {
          576: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
          992: {
            slidesPerView: 4,
          },
          1200: {
            slidesPerView: 5,
          },
        },
        pagination: {
          el: '#swiper-features .swiper-pagination',
          dynamicBullets: false,
          clickable: true,
        },
      });
    },

    // STEP 3 and 4 - init swiper for print zones on product photo
    initPrintZoneSwiper: () => {
      if (!document.querySelector('#swiper-print-zone')) {
        return;
      }

      const thumbBox = document.querySelector('#product_photos');
      const thumbs = thumbBox.querySelectorAll('[data-thumb]');
      const activeClass = 'border-primary';
      const removeActiveClass = (className) => thumbs.forEach((thumb) => thumb.classList.remove(className));

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', (e) => {
          swipers.zoneSwiper.slideTo(jsKit.getIndex(thumbs, e.target), 500);
        });
      });

      const zoneSwiper = new Swiper('#swiper-print-zone');

      swipers.zoneSwiper = zoneSwiper;

      zoneSwiper.on('slideChangeTransitionStart', () => {
        removeActiveClass(activeClass);
        thumbs[zoneSwiper.activeIndex].classList.add(activeClass);

        const outfitsList = document.querySelector('#swiper-outfits-list');

        // turn team thumbnails
        if (outfitsList) {
          // load slot configuration panel
          kitman.loadKitbuilderSlotItem(thumbs[zoneSwiper.activeIndex].dataset.productView, 1);
          // ghost turn
          kitman.loadGhostViewById(thumbs[zoneSwiper.activeIndex].dataset.ghostView, 1);
        } else {
          // load slot configuration panel
          kitman.loadKitbuilderSlot(thumbs[zoneSwiper.activeIndex].dataset.productView, 1);
          // ghost turn
          kitman.loadGhostViewById('next', 0);
        }
      });
    },

  };
})();
